<!-- Not Complete -->
<div
  style="height: 100%; width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center"
>
  <h2>Not Complete</h2>
  <h4>The inspection you are trying to access is not complete or was unsuccessful.</h4>
</div>
<!-- Not Complete-->
